import React, {useEffect, useState} from 'react';
import "../../main/main.css";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import {useDispatch, useSelector} from "react-redux";
import API, {addPenniesItem, getStoreID} from "./Api";
import {getProductsTotalSum} from "../../redux/selectors";
import {
    setPenniesDonation
} from "../../redux/actions";
import {Loader} from "../../main/Loading";
import {PerfectScrollbarWithHotfix as PerfectScrollbar} from "../../uiComponents/WrappedPerfectScrollBar";

const CharityImage = ({src, alt}) => {
    return <div style={{
        width: "50%",
        height: "100%",
        display: "flex",
        alignItems: "center"
    }}>
        <img style={{
            height: "100%",
            maxHeight: "150px",
            maxWidth: "150px",
            margin: "0 auto"
        }} src={src}  alt={alt}/>
    </div>
}

const addDonationProduct = (dispatch, donationAmount, state, charity) => {
    let thankYouShown = false;
    let donationProductAdded = false;
    setTimeout(() => {
        thankYouShown = true;
        if(donationProductAdded){
            dispatch(setPenniesDonation(true, donationAmount, charity));
        }
    }, 2000);
    addPenniesItem(dispatch, state, donationAmount).then(() => {
        donationProductAdded = true;
        if(thankYouShown){
            dispatch(setPenniesDonation(true, donationAmount, charity));
        }
    }, () => {});
}

const AskDonation = () => {
    let state = useSelector(state => state);
    let storeID = getStoreID(state);
    let cashierMode = state.rootReducer.cashierMode;
    let basketTotal = getProductsTotalSum(state.rootReducer.productsInBasket);
    let dispatch = useDispatch();
    let [donationAmounts, setDonationAmounts] = useState([]);
    let [charity, setCharity] = useState({});
    let [donationSet, setDonation] = useState(false);

    useEffect(() => {
        if(cashierMode){
            dispatch(setPenniesDonation(true, false));
        }else{
            API.calculation(basketTotal, storeID, state).then((response) => {
                if(typeof response?.charities?.[0] !== "undefined"){
                    setDonationAmounts([response.donation_amount, ...(response?.additional_donation_amounts ?? [])]);
                    setCharity(response.charities[0]);
                }else{
                    dispatch(setPenniesDonation(true, false));
                }
            },(response) => {
                console.log("Pennies: API.calculation failed", {response});
                dispatch(setPenniesDonation(true, false));
            })
        }
        return () => {}
    }, []);

    if(typeof charity.heading === "undefined"){
        return <Loader position={"absolute"}/>
    }

    let paymentButton = (
        <div style={{margin: "14px 0"}} onClick={e => {
            dispatch(setPenniesDonation(true, donationSet));
        }}>
            <Button
                buttonStyle={{minWidth: "300px"}}
                type="button"
                className={"largeButton yellowButton"}
                name={<Translate id="Proceed"/>}
            />
        </div>
    );
    let DonationButton = ({amount}) => {
        return <div style={{
            marginBottom: "14px",
            textAlign: "center"
        }} onClick={e => {
            setDonation(amount);
            addDonationProduct(dispatch, amount, state, charity);
        }}>
            <Button
                buttonStyle={{
                    minWidth: "300px",
                    fontSize: "20px",
                    backgroundColor: "#79b741",
                    padding: "20px 0",
                    borderRadius: "40px",
                    marginTop: "10px"
                }}
                className={""}
                type="button"
                name={<Translate id={'Donate ${value} to charity'} values={{value: amount}}/>}
            />
        </div>
    };

    if(cashierMode){
        return <></>;
    }

    let charityName = charity?.name ?? "charity";
    let headingMessage = (charity?.heading ?? "Would you like to give [donation_amount] to support ${charityName}?").trim().replace("[donation_amount]","${value}");

    let content;
    if(donationSet){
        content = <>
            <div style={{
                whiteSpace: "pre-wrap",
                marginBottom: "5px",
                fontSize: "24px",
                minHeight: 200,
                textAlign: "center",
                marginTop: 54
            }} className={"boldUppercaseText"}>
                <Translate id={charity?.thank_you_message ?? "Thank you for the donation"}/>
            </div>
        </>
    }else{
        content = <>
            <div style={{
                whiteSpace: "pre-wrap",
                marginBottom: "5px",
                fontSize: "24px"
            }} className={"boldUppercaseText"}>
                <Translate id={headingMessage} values={{value: donationAmounts[0], charityName}}/>
            </div>
            <div style={{
                fontSize: "16px",
                width: "100%",
                margin: "20px auto"
            }}>
                <Translate id={(charity?.soundbite_message ?? "Your micro-donation will help make a difference by providing expert support, funding and care for people most in need").trim()}/>
            </div>
            {donationAmounts.map((amount) => <DonationButton amount={amount}/>)}
            <div style={{
                fontSize: "16px",
                width: "100%",
                margin: "30px auto 20px"
            }}>
                <Translate id={(charity?.solicitation_message ?? "Every penny you give goes to charity").trim()}/>
            </div>
        </>;
    }

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            inset: 0
        }}>
            <div style={{
                flex: 1,
                overflow: "hidden"
            }}>
            <PerfectScrollbar
                style={{
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <div style={{
                    backgroundColor: "#ebebeb",
                    padding: "20px 40px 0",
                    textAlign: "left"
                }}>
                    {content}
                </div>
                <div style={{
                    display: "flex",
                    flexGrow: 1,
                    minHeight: 100
                }}>
                    <CharityImage
                        src={charity?.charity_logo_url ?? ""}
                        alt={charityName}
                    />
                    <CharityImage
                        src={charity?.pennies_logo_url ?? ""}
                        alt={"pennies"}
                    />
                </div>
            </PerfectScrollbar>
            </div>
            {paymentButton}
        </div>
    );
}

export default AskDonation;